import React from 'react'
import { VISUAL_BUILDER_GUIDE_NOTE } from './layoutBuilderCopy'
import './layoutBuilder.css'

// Neutral info note (not a warning) shown for Visual Builder integrations and flows.
export default function GuideNote () {
  return (
    <p className='layoutBuilder-info-note' role='note'>
      <i className='pi pi-info-circle' aria-hidden='true' />
      <span>{VISUAL_BUILDER_GUIDE_NOTE}</span>
    </p>
  )
}
